// CompletedSheetsList.jsx
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import SheetsFilters from "../Common/SheetsFilters";
import SheetPreview from "../Common/SheetPreview";
import DownloadButton from "../Common/DownloadButton";

export default function CompletedSheetsList({ companyId }) {
  const [filters, setFilters] = useState({
    namePart: "",
    startTime: null,
    endTime: null,
  });

  const [sheets, setSheets] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const fetchSheets = async () => {
    try {
      const res = await api.post("/cutting/sheets/completed", filters, {
        params: { 
          companyId: companyId 
        }
      });
      setSheets(res.data.elements || []);
    } catch (err) {
      console.error("Ошибка загрузки завершенных листов:", err);
    }
  };

  useEffect(() => {
    if (companyId) {
      fetchSheets();
    }
  }, [companyId]);

  const downloadSheet = async (id, name, cutMachineType) => {
    const response = await api.post(`/cutting/sheets/download/${id}`, null, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    const extension = cutMachineType == 2 ? ".ArmsData" : ".dxf";
    link.setAttribute("download", name + extension);
    link.click();
    link.remove();
  };

  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  return (
    <>
      <SheetsFilters
        filters={filters}
        setFilters={setFilters}
        onSearch={fetchSheets}
      />

      {sheets.map((s) => (
        <div key={s.id} className="border rounded p-2 mb-2">
          <div
            className="d-flex justify-content-between"
            onClick={() => toggleExpand(s.id)}
            style={{ cursor: "pointer" }}
          >
            <div>
              <div className="fw-bold">{s.name}</div>
              <small className="text-muted">
                {new Date(s.creationTime).toLocaleString()}
              </small>
            </div>

            <div>
              {s.cutMachineType == 2 && (
                <span className="ms-2 badge bg-primary">Плоттер</span>
              )}
              {s.isNew === true && (
                <span className="ms-2 badge bg-success">Новый</span>
              )}
            </div>

            <div className="col-md-3 col-6">
              <small className="text-muted d-block">Создатель:</small>
              <div>{s.createdBy}</div>
            </div>
          </div>

          {expanded === s.id && (
            <div className="card-footer d-flex flex-column gap-2">
              <div className="mt-2">
                <SheetPreview jobId={s.jobId} />
              </div>

              <div className="d-flex flex-wrap gap-2">
                <DownloadButton
                  endpoint={`/cutting/sheets/download/${s.id}`}
                  buttonLabel={s.cutMachineType == 2 ? "Скачать .ArmsData" : "Скачать .dxf"}
                  method="post"
                  defaultFileName="sheet.dxf"
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
}